export enum ChangeTypeEnum {
  AddEmpty = 'AddEmpty',
  AddMetric = 'AddMetric',
  AddHeader = 'AddHeader',
  AddFormula = 'AddFormula',
  EditInfo = 'EditInfo',
  EditChart = 'EditChart',
  EditFormula = 'EditFormula',
  EditParameters = 'EditParameters',
  EditListeners = 'EditListeners',
  Delete = 'Delete',
  Move = 'Move'
}
